import React from 'react';

/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { routeChangeListener, RouteChangeListener } from 'ui/hoc/routeChangeListener';
 * import { testView as TestView } from 'views/Test.view';
 *
 * // create a component
 * const ComponentWithHOC = RouteChangeListener( TestView );
 * @return {class} - A standard React component
 */
const routeChangeListener = ( Component ) => {
    class RouteChangeListener extends React.Component {
        constructor( props ) {
			super( props );

			// bind methods
            this.onRouteChange = this.onRouteChange.bind( this );

            // listen to history changes
            this.unlisten = props.history.listen( this.onRouteChange );
        }
        
        /******************************/

		// on route change
        onRouteChange() {
            log.debug( 'RouteChangeListener.onRouteChange()' );

            this.cleanup(); // perform cleanup

            this.scrollToTop(); // scrolls to top of page
        }

        // clean up on history change
        cleanup() {
            log.debug( 'RouteChangeListener.cleanup()' );
        }

        scrollToTop() {
            log.debug( 'RouteChangeListener.scrollToTop()' );

            // Scrolls page to top always
            // upon new route change
            setTimeout( () => {
                window.scrollTo( 0, 0 );
            }, 0 );
        }
        
        /******************************/

        // when component mounts, perform initial cleanup
		componentDidMount() {
			this.cleanup();
		}

        // when component unmounts, remove history listener
        componentWillUnmount() {
			this.unlisten();
        }

        render() {
            return (
                <Component { ...this.props } />
            );
        }
    }

    // set display name
    RouteChangeListener.displayName = 'RouteChangeListener';

    // set default props
    RouteChangeListener.defaultProps = {};

    // return class
    return RouteChangeListener;
};

export { routeChangeListener };
